var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemMasterConfig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66406C14.1421 6.66406 17.5 5.54477 17.5 4.16406C17.5 2.78335 14.1421 1.66406 10 1.66406C5.85786 1.66406 2.5 2.78335 2.5 4.16406C2.5 5.54477 5.85786 6.66406 10 6.66406Z",
    stroke: "#67768E",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.4988 10.466 2.88829 10.9228 3.62453 11.3189C4.36076 11.7149 5.41444 12.0346 6.66667 12.2417",
    stroke: "#67768E",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.7474V4.16406",
    stroke: "#67768E",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16406V15.8307C2.49947 16.3713 3.0246 16.8974 3.99667 17.3301C4.96873 17.7628 6.33535 18.0788 7.89167 18.2307",
    stroke: "#67768E",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7865 10.1233C13.8071 10.0859 13.8373 10.0548 13.874 10.0331C13.9106 10.0114 13.9525 10 13.9951 10C14.0377 10 14.0795 10.0114 14.1162 10.0331C14.1529 10.0548 14.1831 10.0859 14.2037 10.1233L15.6094 12.7918C15.6429 12.8536 15.6897 12.9072 15.7464 12.9488C15.8031 12.9904 15.8683 13.0189 15.9373 13.0322C16.0063 13.0456 16.0774 13.0436 16.1455 13.0262C16.2137 13.0088 16.2771 12.9766 16.3313 12.9318L18.3679 11.1871C18.407 11.1553 18.4552 11.1367 18.5055 11.134C18.5559 11.1313 18.6057 11.1447 18.648 11.1722C18.6902 11.1997 18.7227 11.2398 18.7406 11.2869C18.7586 11.334 18.7612 11.3856 18.7479 11.4342L17.3984 16.3133C17.3709 16.4131 17.3115 16.5012 17.2294 16.5643C17.1472 16.6274 17.0468 16.662 16.9432 16.6628H11.0475C10.9438 16.6621 10.8432 16.6275 10.761 16.5645C10.6787 16.5014 10.6193 16.4132 10.5918 16.3133L9.24271 11.4347C9.22949 11.3861 9.23205 11.3345 9.25001 11.2874C9.26797 11.2403 9.30041 11.2001 9.34266 11.1727C9.38491 11.1452 9.43478 11.1318 9.48511 11.1345C9.53543 11.1372 9.58361 11.1557 9.62271 11.1875L11.6589 12.9323C11.7131 12.9771 11.7765 13.0093 11.8446 13.0267C11.9128 13.044 11.9839 13.0461 12.0529 13.0327C12.1219 13.0193 12.1871 12.9908 12.2438 12.9493C12.3005 12.9077 12.3473 12.8541 12.3808 12.7923L13.7865 10.1233Z",
    stroke: "#67768E",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 18.5703H17.3307",
    stroke: "#67768E",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemMasterConfig);
export default __webpack_public_path__ + "static/media/itemMasterConfig.e8db950002c7a6d0fe97d0e0df2adf30.svg";
export { ForwardRef as ReactComponent };